import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ROUTES_STORE } from './side-nav-store-routes.config';
import { ROUTES_DRIVER } from './side-nav-driver-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { AuthGuardService } from '../../services/AuthGuardService';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
  styles: ['@media print { .side-nav { display: none; } }']
})

export class SideNavComponent{

  public menuItems: any[]
  isFolded : boolean;
  isSideNavDark : boolean;

  constructor( private themeService: ThemeConstantService, private authService : AuthGuardService) {}

  ngOnInit(): void 
  {
    	if(this.authService.mUser.role.admin)
      		this.menuItems = ROUTES.filter(menuItem => menuItem);
		else if(this.authService.mUser.role.store)
		{	
			console.log(localStorage.getItem('userStoreRole') )
		  	if(localStorage.getItem('userStoreRole') != 'undefined' && localStorage.getItem('userStoreRole') != undefined && localStorage.getItem('userStoreRole') != null)
		  	{
				let storeRole = JSON.parse(localStorage.getItem('userStoreRole'))
				let tempMenu = ROUTES_STORE.filter(menuItem => menuItem);
				if(tempMenu == undefined || storeRole === '')
				{
					this.menuItems = ROUTES_STORE.filter(menuItem => menuItem);
				}
				else
				{
					let s_menu = []
					tempMenu.forEach(element => 
					{	
						let mmm = element.path.substring(1)
						if (storeRole[mmm]) {
							s_menu.push(element)
						}
					});

					this.menuItems = s_menu
				}
      		} else {
	        	this.menuItems = ROUTES_STORE.filter(menuItem => menuItem);
     		}
    	}
		else if(this.authService.mUser.role.driver)
			this.menuItems = ROUTES_DRIVER.filter(menuItem => menuItem);

		this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
		this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
  	}
}
